export default "__VITE_ASSET__CWjjqVfk__"